import { IndustryConfig } from '../../../types'

export const heavyEquipmentConfig: IndustryConfig = {
  id: 'heavy-equipment',
  name: 'Heavy Equipment',
  icon: '���',
  description: 'Heavy machinery and industrial equipment providers',
  
  businessTypes: [
    {
      id: 'mining-equipment',
      name: 'Mining Equipment',
      description: 'Mining and extraction equipment specialists'
    },
    {
      id: 'industrial-machinery',
      name: 'Industrial Machinery',
      description: 'Manufacturing and processing equipment'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'equipment-sales',
      name: 'Equipment Sales',
      description: 'Heavy machinery and equipment sales',
      intelligenceValue: "We'll monitor commodity prices and industrial production trends."
    }
  ],
  
  supplierCategories: [
    {
      id: 'oem-partners',
      name: 'OEM Partners',
      suppliers: ['Caterpillar', 'Liebherr', 'Sandvik', 'Atlas Copco'],
      spendRanges: ['Under $100K', '$100K-$500K', '$500K-$2M', 'Over $2M']
    }
  ],
  
  competitiveFactors: [
    'Technical expertise',
    'Service network coverage',
    'Parts availability',
    'Equipment reliability'
  ]
}
